

import { Modal, Box, SpaceBetween, Button } from '@cloudscape-design/components'
import { Suspense, lazy, useContext, useRef } from 'react'

import { EmailTaskSettings } from './EmailTask.tsx'
import { PhoneTaskSettings } from './PhoneTask.tsx'
import { SendFATaskSettings } from './SendFATask.tsx'
import { ReceiveDocumentsTaskSettings } from './ReceiveDocumentsTask.tsx'
import { UserActivityTaskSettings } from './UserActivityTask.tsx'
import { QuickCaseTaskSettings } from './QuickCaseTask.tsx'
import { SetTaskContext } from '../Layout.tsx'

type Exec = () => Promise<string>

const Loadable = (Component: any) => (props: {values: any, setMessage: (s: string) => void, execRef: React.MutableRefObject<Exec>}) =>
(
<Suspense fallback={<span>Loading</span>}>
    <Component {...props} />
</Suspense>
)

const PhoneTask =             Loadable(lazy(() => import('./PhoneTask.tsx')))
const EmailTask =             Loadable(lazy(() => import('./EmailTask.tsx')))
const SendFATask =            Loadable(lazy(() => import('./SendFATask.tsx')))
const ReceiveDocumentsTask =  Loadable(lazy(() => import('./ReceiveDocumentsTask.tsx')))
const UserActivityTask =      Loadable(lazy(() => import('./UserActivityTask.tsx')))
const QuickCaseTask =         Loadable(lazy(() => import('./QuickCaseTask.tsx')))

let message = ""
 
export const TaskDialog = ({taskName, close, values}: {taskName: string, close: () => void, values: any}) => {
  const setTask = useContext(SetTaskContext)
  let title = "No Title Set"
  let size = "large"
  switch (taskName) {
    case "PhoneTask":
      title = PhoneTaskSettings.title; size = PhoneTaskSettings.size; break
    case "EmailTask":
      title = EmailTaskSettings.title; size = EmailTaskSettings.size; break
    case "SendFATask":
      title = SendFATaskSettings.title; size = SendFATaskSettings.size; break
    case "ReceiveDocumentsTask":
      title = ReceiveDocumentsTaskSettings.title; size = ReceiveDocumentsTaskSettings.size; break
    case "UserActivityTask":
      title = UserActivityTaskSettings.title; size = UserActivityTaskSettings.size; break
    case "QuickCaseTask":
      title = QuickCaseTaskSettings.title; size = QuickCaseTaskSettings.size; break
  }

  const execRef = useRef<Exec>(null)

  function setMessage(s: string, type: "success" | "info" | "warning" | "error" = "info") {
    if (message === s) return // No change, no need to update
    message = s // Store the message to avoid unnecessary updates
    const typeColors = {success: "#0A0", info: "#888", warning: "#FF0", error: "#F00"}
    const endColors = {success: "#8F8", info: "#F0F0F0", warning: "#CC0", error: "#FAA"}
    const flashColor = typeColors[type] || "#AAA"
    const endColor = endColors[type] || "#F0F0F0"
    const mess = document.getElementById("taskMessage")
    if (mess) {
      mess.textContent = (s === "") ? "..." : s 
      if (!s) {
        // mess.style.background = "transparent"
      } else {
        mess.animate([
          { background: "#AAA" }, { background: flashColor },
          { background: flashColor }, { background: endColor },
        ], { duration: 500, fill: 'forwards' })
        mess.style.background = endColor
      }
    }
  }

  async function execute() {
    setMessage("Submitting...")
    if (execRef.current) {
      const result = await execRef.current()
      if (result.startsWith('ERROR:')) {setMessage(result, "error"); return}
      if (result.startsWith('TASK:' )) {setTask(result.substring(5), values); return}
      close()
    } else {
      setMessage("Internal Error: execute function not set", "error")
      console.error("Internal Error: execute function not set")
    }
  }

  function TaskPanel({taskName, values, setMessage, execRef}:
    {taskName: string, values: any, setMessage: (s: string) => void, execRef: React.MutableRefObject<Exec>}) {
    switch (taskName) {
      case "PhoneTask":
        return (<PhoneTask values={values} setMessage={setMessage} execRef={execRef} />)
      case "EmailTask":
        return (<EmailTask values={values} setMessage={setMessage} execRef={execRef} />)
      case "SendFATask":
        return (<SendFATask values={values} setMessage={setMessage} execRef={execRef} />)
      case "ReceiveDocumentsTask":
        return (<ReceiveDocumentsTask values={values} setMessage={setMessage} execRef={execRef} />)
      case "UserActivityTask":
        return (<UserActivityTask values={values} setMessage={setMessage} execRef={execRef} />)
      case "UserActivityTask":
        return (<UserActivityTask values={values} setMessage={setMessage} execRef={execRef} />)
      case "QuickCaseTask":
        return (<QuickCaseTask values={values} setMessage={setMessage} execRef={execRef} />)
      default:
        return (<h1>Task not found: {taskName}</h1>)
    }
  }

  return (
    <form id="taskForm" onSubmit={event => { event.preventDefault(); event.currentTarget.disabled = true; execute() }}>
    <Modal size={size as any}
      onDismiss={close}
      visible={!!taskName}
      header={title}
      footer={<>
        <Box float="left"><span id="taskMessage">{values?.message ?? ""}</span></Box>
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
              <Button variant="link"    onClick={event => close()  }>Cancel</Button>
              <Button variant="primary" form="taskForm" formAction='submit'>Ok</Button>
          </SpaceBetween>
        </Box>
      </>}>
      <TaskPanel taskName={taskName} values={values} setMessage={setMessage} execRef={execRef as React.MutableRefObject<() => Promise<string>>} />
    </Modal>
    </form> 
  )
}

